// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action[data-v-fa060b30]{color:#ff4d4f!important}", ""]);
// Exports
module.exports = exports;
